import { AxiosInstance, AxiosError } from "axios";
import { BaseApi } from "../base-api";
import {
  IFavoriteProjectResponseModel,
  IFavoriteProjectsApi,
} from "@lib/types";

export class FavoriteProjectsApi
  extends BaseApi
  implements IFavoriteProjectsApi
{
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async get(
    userId: number,
    accountNumber: number,
  ): Promise<Array<IFavoriteProjectResponseModel>> {
    try {
      const response = await this._instance.get<
        Array<IFavoriteProjectResponseModel>
      >(`/users/${userId}/accounts/${accountNumber}/projects`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async post(
    userId: number,
    accountNumber: number,
    projectId: number,
  ): Promise<void> {
    try {
      await this._instance.post(
        `/users/${userId}/accounts/${accountNumber}/projects`,
        { id: projectId },
      );
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async delete(
    userId: number,
    accountNumber: number,
    projectId: number,
  ): Promise<void> {
    try {
      await this._instance.delete(
        `/users/${userId}/accounts/${accountNumber}/projects/${projectId}`,
      );
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }
}
